import { IPriceScheme, IPriceSchemeResponse } from 'src/types/price.types';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import dayjs from 'dayjs';

export const getAllPriceSchemes = async (): Promise<IPriceScheme[]> => {
  try {
    const res = await fetch(`${API_URL}/pricing/schemes`);

    if (!res.ok) throw new Error();

    const { data }: IPriceSchemeResponse = await res.json();

    return data.map(({ price_scheme_id, name, publication_status, modification_date, status, event_id }) => ({
      id: price_scheme_id,
      name,
      publicationStatus: publication_status,
      modificationDateTime: dayjs(modification_date),
      status: status,
      eventId: event_id ?? null,
    }));
  } catch {
    throw new Error('Could not fetch price schemes');
  }
};
